import { render, staticRenderFns } from "./ResourceDescriptionPreviewsList.vue?vue&type=template&id=4535dcd4&scoped=true&"
import script from "./ResourceDescriptionPreviewsList.vue?vue&type=script&lang=ts&"
export * from "./ResourceDescriptionPreviewsList.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDescriptionPreviewsList.vue?vue&type=style&index=0&id=4535dcd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535dcd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4535dcd4')) {
      api.createRecord('4535dcd4', component.options)
    } else {
      api.reload('4535dcd4', component.options)
    }
    module.hot.accept("./ResourceDescriptionPreviewsList.vue?vue&type=template&id=4535dcd4&scoped=true&", function () {
      api.rerender('4535dcd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourceDescriptionPreviewsList.vue"
export default component.exports